import { Component, OnInit } from '@angular/core';
import { Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import { Textbox } from './../../models/editors/textbox.model';
import { Switch } from './../../models/editors/switch.model';

import { PageTile } from './../../models/pagetiles/pagetiles.model';

import { ApiService } from './../../shared/services/api.service';
import { FormControlService } from './../../shared/services/form-control.service';
import { AlertService } from './../../shared/services/alert.service';
import { Dropdown } from './../../models/editors/dropdown.model';
import { Page } from './../../models/pages/pages.model';
import { atLeastOneLang } from './../../shared/validators/langField.validator';
import { Contained } from './../../models/editors/contained.model';
import { FormDetailBase } from './../../shared/components/base/form-detail/form-detail.base.component';
import { EntityService } from './../../shared/services/entity.service';
import { Textarea } from './../../models/editors/textarea.model';

@Component({
  selector: 'swb-page-tile-detail',
  templateUrl: './../../shared/components/base/form-detail/form-detail.base.component.html',
  providers: [FormControlService]
})
export class PageTileDetailComponent extends FormDetailBase<PageTile> implements OnInit {
  public url = 'pagetiles';
  protected _redirect = './pages';

  public entity = new PageTile({});
  public pages: Array<Page>;

  public get fieldsConfig(): Array<any> {
    return [
      new Textarea({
        key: 'title',
        label: 'Nadpis dlaždice',
        validators: [atLeastOneLang],
        isMultilang: true
      }),
      new Textarea({
        key: 'content',
        label: 'Text dlaždice',
        validators: [],
        isMultilang: true
      }),
      new Switch({
        key: 'custom_link',
        label: 'Vlastní odkaz',
        isMultilang: true,
        labelFalse: 'Odkazovat na stránku'
      }),
      new Textbox({
        key: 'link',
        label: 'Vlastní odkaz',
        validators: [],
        isMultilang: true,
        boundTo: 'custom_link'
      }),
      new Dropdown({
        key: 'page_id',
        label: 'Stránka, na kterou odkazuje',
        isMultilang: false,
        options: this._formService.getDropdownValues('title', this.pages)
      })
    ];
  }

  constructor(
    _formService: FormControlService,
    _apiService: ApiService,
    _router: Router,
    _alertService: AlertService,
    private _route: ActivatedRoute,
    private _entityService: EntityService
  ) {
    super(
      _formService,
      _apiService,
      _router,
      _alertService
    );
  }

  ngOnInit() {
    if (typeof this._route.snapshot.params['id'] !== 'undefined') {
      this._id = this._route.snapshot.params['id'];
    }

    if (this._route.outlet === 'modal-form') {
      this.isModal = true;
      this._redirect = undefined;
      this._saveCallback = this._saveCallback = (response) => {
        const item = { ...response }.data;
        this._entityService.setChosenEntities([item], 'pagetiles');
        this._closeCallback();
      };
      this._closeCallback = () => {
        this._router.navigate([{ outlets: { 'modal-form': null } }], {
          relativeTo: this._route.parent
        });
      };
      this._id = undefined; // TODO: better?
      window.scrollTo(0, 0);
    }

    this._getPagesList();

  }

  private _getPagesList() {
    this._apiService.get('pages/list')
      .subscribe(
        (response: any) => {
          this.pages = { ...response }.data;

          this._getEntity();

          this._setupForm();
        },
        (error) => console.error(error)
      );
  }
}
